import { ARTICLES_LIMIT } from '../../utils/constants';
import {
    FETCH_ARTICLES_GTTIPS_CLEAN_UP,
    FETCH_ARTICLES_GTTIPS_FAILURE,
    FETCH_ARTICLES_GTTIPS_REQUEST,
    FETCH_ARTICLES_GTTIPS_SUCCESS,
    FETCH_ARTICLES_GTTIPS_TRANSLATED_SUCCESS,
    UPDATE_GTTIPS_PAGE_START_PARAM,
} from '../constants/gtTipsTypes';

const initialState = {
    loading: false,
    articles: [],
    error: '',
    start: 0,
};

const articlesGtTipsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ARTICLES_GTTIPS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ARTICLES_GTTIPS_SUCCESS:
            return {
                loading: false,
                articles: [...state.articles, ...action.payload.articles],
                error: '',
                start: state.start,
            };
        case FETCH_ARTICLES_GTTIPS_TRANSLATED_SUCCESS:
            return {
                loading: false,
                articles: action.payload.articles,
                error: '',
                start: 0,
            };
        case FETCH_ARTICLES_GTTIPS_FAILURE:
            return {
                loading: false,
                article: null,
                error: action.payload,
            };
        case FETCH_ARTICLES_GTTIPS_CLEAN_UP:
            return {
                articles: [],
            };
        case UPDATE_GTTIPS_PAGE_START_PARAM:
            return {
                ...state,
                start: state.start + ARTICLES_LIMIT,
            };
        default:
            return state;
    }
};

export default articlesGtTipsReducer;
